import React from "react";
import { SunIcon, MoonIcon, MonitorIcon, PaintBrushIcon } from "./SettingsIcons";

const THEMES = [
  { id: "light", label: "Light", icon: SunIcon },
  { id: "dark", label: "Dark", icon: MoonIcon },
  { id: "system", label: "System", icon: MonitorIcon },
];

const SettingsAppearanceTab = ({
  theme,
  setTheme,
  sidebarPosition,
  setSidebarPosition,
  compactMode,
  setCompactMode,
}) => {
  return (
    <div className="v2-settings-pg-card">
      <div className="v2-settings-pg-card__header">
        <div className="v2-settings-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <PaintBrushIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-settings-pg-card__title">Appearance Settings</h3>
          <p className="v2-settings-pg-card__subtitle">
            Customize the look and feel of your dashboard
          </p>
        </div>
      </div>

      <div className="v2-settings-pg-card__body">
        {/* Theme Selector */}
        <div className="v2-settings-pg-field">
          <label className="v2-settings-pg-field__label">Theme</label>
          <div className="v2-settings-pg-themes">
            {THEMES.map((t) => {
              const Icon = t.icon;
              const isActive = theme === t.id;
              return (
                <button
                  key={t.id}
                  className={`v2-settings-pg-theme-card${isActive ? " v2-settings-pg-theme-card--active" : ""}`}
                  onClick={() => setTheme(t.id)}
                >
                  <Icon size={24} color={isActive ? "#eb1414" : "#6b7280"} />
                  <span className="v2-settings-pg-theme-card__label">{t.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Sidebar Position */}
        <div className="v2-settings-pg-field">
          <label className="v2-settings-pg-field__label">Sidebar Position</label>
          <select
            className="v2-settings-pg-select"
            value={sidebarPosition}
            onChange={(e) => setSidebarPosition(e.target.value)}
          >
            <option value="left">Left</option>
            <option value="right">Right</option>
          </select>
        </div>

        {/* Compact Mode */}
        <div className="v2-settings-pg-toggle-row">
          <div className="v2-settings-pg-toggle-row__text">
            <span className="v2-settings-pg-toggle-row__label">Compact Mode</span>
            <span className="v2-settings-pg-toggle-row__desc">
              Reduce spacing and padding for a more compact view
            </span>
          </div>
          <button
            className={`v2-settings-pg-toggle${compactMode ? " v2-settings-pg-toggle--on" : ""}`}
            onClick={() => setCompactMode(!compactMode)}
          >
            <span className="v2-settings-pg-toggle__knob" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsAppearanceTab;
